
import React from 'react';
import Highcharts from 'highcharts';
import highchartsMore from 'highcharts/highcharts-more';
import HighchartsReact from 'highcharts-react-official';
import solidGauge from 'highcharts/modules/solid-gauge';
import Box from "@mui/material/Box";

// Initialize highcharts-more and solid-gauge modules
highchartsMore(Highcharts);
solidGauge(Highcharts);

interface CustomGaugeProps {
    value: number;
    color?: string;
}

const CustomGauge = ({value, color} :CustomGaugeProps) => {

    const data = value < 5 ? [] : [Number(value)];

    const options = {
        exporting: {
            enabled: false,
        },
        accessibility: {
            enabled: false,
        },
        chart: {
            type: 'gauge',
            backgroundColor: 'transparent',
            height: '60%'
        },
        tooltip: {
            enabled: false
        },
        title: {
            text: undefined
        },
        credits: {
            enabled: false
        },
        pane: {
            startAngle: -90,
            endAngle: 90,
            background: undefined,
            center: ['45%', '90%'],
            size: '150%'
        },
        yAxis: {
            min: 0,
            max: 10,
            lineWidth: 0,
            tickPositions:[5,6,7,8,9,10],
            tickColor: '#64748B',
            tickWidth: 2,
            minorTickWidth: 0,
            labels: {
                distance: 25,
                style: {
                    color: '#374151',
                    fontSize: '16px',
                    fontWeight: '500'
                }
            },
            plotBands: [
                { from: 0, to: 5, color: '#e2cab6', innerRadius: '80%', outerRadius: '100%' },
                { from: 5, to: 7, color: '#cbd5e1', innerRadius: '80%', outerRadius: '100%' },
                { from: 7, to: 9, color: '#9cbbf3', innerRadius: '80%', outerRadius: '100%' },
                { from: 9, to: 10, color: '#a4c9c3', innerRadius: '80%', outerRadius: '100%' },
                { from: 0, to: value, color: color, innerRadius: '80%', outerRadius: '100%' }
            ]
        },
        plotOptions: {
            gauge: {
                dial: {
                    radius: '0%',
                },
                pivot: {
                    radius: 0,
                    borderWidth: 0,
                },
            },
        },
        series: [
            {
                type: 'gauge',
                name: 'Nota',
                data: data,
                dataLabels: {
                    enabled: true,
                    borderWidth: 0,
                    border: "none",
                    color: color,
                    align: 'center',
                    verticalAlign: 'top',
                    x: 0,
                    y: -60,
                    style: {
                        fontSize: '40px',
                        textOutline: "none",
                    }
                }
            },
        ],
    };

    return (
        <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
            <HighchartsReact
                highcharts={Highcharts}
                options={options}
                containerProps={{ style: { width: '100%', maxWidth: '400px' } }}
            />
        </Box>
    );
};

export default CustomGauge;